import {AbstractControl, Validators} from '@angular/forms';

/** Controls whose `Validators.required` this helper removed, so it can put back exactly that one. */
const suspended = new WeakSet<AbstractControl>();

/**
 * ISS-178: a control the client cannot see must not block Next, but it must keep its value — a cloned
 * or edited case carries stored amounts the step does not ask for, and the step serializes from the
 * form value (which omits disabled controls). So an unasked control stays enabled and only loses the
 * `Validators.required` that processForm gave it; it gets that back once it is asked again.
 *
 * Only that one validator (by reference) is touched, and only on a change of state: validators other
 * code registers later — the rent-history uniqueness check, datepicker parse validators — are left alone.
 */
export function setControlAsked(control: AbstractControl, asked: boolean): void {
  if (asked) {
    if (suspended.delete(control)) {
      control.addValidators(Validators.required);
      control.updateValueAndValidity({emitEvent: false});
    }
  } else if (!suspended.has(control) && control.hasValidator(Validators.required)) {
    control.removeValidators(Validators.required);
    suspended.add(control);
    control.updateValueAndValidity({emitEvent: false});
  }
}
